export class Contact {
  'g-recaptcha-response': string;
  first_name: string;
  last_name: string;
  message: string;
  phone: string;
  email: string;
  referrer_url: string;
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  marketing_accepted: boolean = false;
  request_room_count: number;
  re_captcha_version: string;
}



// WEBPACK FOOTER //
// ./src/app/common-theme/models/contact.model.ts